import { Injectable } from '@angular/core';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { environment } from '../../../environments/environment';
import { UserService } from 'app/_services/user.service';

@Injectable({ providedIn: 'root' })
export class PartManagerRelatorioFinanceiroService extends BaseService {
    private _apiSellerUrl: string = `${environment.apiSeller}`;
    private _domain: string = '/part-manager/reports';

    constructor(private userService: UserService, private config: SettingsService) {
        super();
    }

    public carregarDadosHolding() {
        return this.config.executeGet({ url: `${this._domain}/info` });
    }

    public carregarRelatorio(ano_mes: string) {
        if (!ano_mes)
            return this.config.executeGet({ url: `${this._domain}` });

        return this.config.executeGet({ url: `${this._domain}/${ano_mes}` });
    }

    public contestar(items, reason, yearMonth) {
        const userCompanyId = this.userService.user().user_company_id;
        const month = yearMonth.substring(4, 6);
        const year = yearMonth.substring(0, 4);
        const body = { userCompanyId, items, reason, year, month };

        return this.config.executePost({ baseUrl: `${this._apiSellerUrl}`, url: '/disputes', body });
    }

    public listarMeses() {
        const quantity = 12;
        return this.config.executeGet({ url: `${this._domain}/months/${quantity}` });
    }
}
